export default {
  index: [
    {
      path: '/qytcorder',
      component: resolve => require(['./qytcorderIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qytcorder/_router.js